<template>
    <div class="calendar-cell relative" :class="classObject">
        <div class="w-full h-full flex items-center justify-center">
            <span class="uppercase font-medium mx-10 leading-5">{{ absence }}</span>
        </div>
        <div class="absolute cell-date">
            <span class="text-xs leading-none">{{ date }}</span>
        </div>
        <div class="absolute cell-actions" v-if="extended">
            <div class="flex items-center">
                <div class="mr-1">
                    <md-button class="md-icon-button md-small-icon md-rounded-icon my-0" :class="type ? 'md-white' : 'md-info'"
                               @click="openAddElementPanel">
                        <font-awesome-icon class="md-icon" :icon="['fa', 'plus']" />
                    </md-button>
                    <md-tooltip md-direction="top">Ajouter un temps divers</md-tooltip>
                </div>
                <div class="mr-1">
                    <md-button class="md-icon-button md-small-icon md-rounded-icon my-0" :class="type ? 'md-white' : 'md-info'"
                               @click="openAddAbsencePanel">
                        <font-awesome-icon class="md-icon" :icon="['fa', 'male']" />
                    </md-button>
                    <md-tooltip md-direction="top">Ajouter une absence</md-tooltip>
                </div>
	            <div>
		            <md-button class="md-icon-button md-small-icon md-rounded-icon my-0" :class="type ? 'md-white' : 'md-success'"
		                @click="refreshDay">
			            <font-awesome-icon class="md-icon" :icon="['fa', 'sync-alt']" :class="{'animate-spin': refreshing}" />
		            </md-button>
		            <md-tooltip md-direction="top">Actualiser la journée</md-tooltip>
	            </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "CalendarAbsenceCell",
    props: {
        type: Number,
        absences: Array,
        extended: Boolean,
        day: Object,
        technician: Object
    },
	data() {
		return {
			refreshing: false
		}
	},
    computed: {
        classObject() {
            return {
                'cell-bg cell-bg-gray': this.type === 1,
                'cell-bg cell-bg-blue': this.type === 2,
                'cell-bg cell-bg-orange': this.type === 3,
                'cell-bg cell-bg-green': this.type === 4,
                'cell-bg cell-bg-red': this.type === 5,
                'cell-bg cell-bg-purple': this.type === 6,
                'cell-bg cell-bg-pink': this.type === 7,
            }
        },
        date() {
            return this.$moment(this.day.date).format('DD/MM/YYYY') + ' - S' + this.day.weekNumber
        },
        absence() {
            return this.absences.map(absence => { return absence.absence_type.name }).join(' / ')
        }
    },
    methods: {
        openAddElementPanel() {
            bus.$emit('open-calendar-panel', {
                type: 'add-element',
                data: {
                    day: this.day,
                    technician: this.technician
                }
            })
        },
        openAddAbsencePanel() {
            bus.$emit('open-calendar-panel', {
                type: 'add-absence',
                data: {
                    day: this.day,
                    technician: this.technician
                }
            })
        },
	    async refreshDay() {
		    try {
			    this.refreshing = true
			    const { data } = await this.$store.dispatch('calendar/refreshDay', {
				    technician_id: this.technician.id,
				    date: this.day.date,
				    weekNumber: this.day.weekNumber
			    })
			    await this.$store.dispatch('alerts/success', 'Journée actualisée')
			    this.$emit('update-cell', data)
			    this.refreshing = false
		    } catch (e) {}
	    },
    }
}
</script>

<style scoped>

</style>
